console.log('Audio-Button Script geladen');

document.addEventListener('DOMContentLoaded', function() {
  var audioButtons = document.querySelectorAll('.audio-load-btn');
  console.log('Buttons gefunden:', audioButtons.length);
  
  audioButtons.forEach(function(button, index) {
    button.addEventListener('click', function() {
      var sku = this.dataset.sku;
      var vendor = this.dataset.vendor;
      var product = this.dataset.product;
      var productType = this.dataset.type;
      
      console.log('Lade Audio:', product, 'von', vendor);
      
      var playerContainer = document.querySelector('.player-container');
      
      if (playerContainer) {
        // Bestehende iframes entfernen
        var existingIframes = playerContainer.querySelectorAll('iframe');
        existingIframes.forEach(function(iframe) {
          iframe.remove();
        });
        
        // Audio URL erstellen (mit korrektem Produkttyp)
        var audioUrl = 'https://geerdes.media/apps/demos/?a=' + sku;
        var height = '100px';
        
        if (productType === 'Midifile' || productType === 'Pro-Midifile' || productType === 'ProV-Midifile') {
          audioUrl += '&o=0';
        } else if (productType === 'Playback') {
          audioUrl += '&o=1';
        } else if (productType === 'Pro-Playback') {
          audioUrl += '&o=2';
        } else if (productType === 'ProV-Playback') {
          audioUrl += '&o=3';
          height = '150px';
        } else {
          audioUrl += '&o=0';
        }
        
        audioUrl += '&iframe&download&color=424548,424548';
        
        // Neues iframe erstellen
        var newIframe = document.createElement('iframe');
        newIframe.src = audioUrl;
        newIframe.style.border = '0';
        newIframe.style.overflowY = 'hidden';
        newIframe.style.width = '100%';
        newIframe.style.height = height;
        newIframe.scrolling = 'no';
        
        playerContainer.appendChild(newIframe);
        
        // Track-Info aktualisieren
        var trackInfo = document.querySelector('.track-info');
        if (trackInfo) {
          // Titel aktualisieren
          var trackTitleSpans = trackInfo.querySelectorAll('span');
          console.log('Gefundene spans:', trackTitleSpans.length);
          
          trackTitleSpans.forEach(function(span, index) {
            console.log('Span', index, ':', span.textContent);
          });
          
          // Ersten span (Titel) aktualisieren
          if (trackTitleSpans.length > 1) {
            trackTitleSpans[1].textContent = product;
            console.log('Titel gesetzt:', product);
          }
          
          // Letzten span (Vendor) aktualisieren  
          if (trackTitleSpans.length > 3) {
            trackTitleSpans[3].textContent = vendor;
            console.log('Vendor gesetzt:', vendor);
          }
        }
        
        console.log('Audio geladen:', product, 'von', vendor);
        
        // ========================================
        // Button Status Update nach Demo-Laden
        // ========================================
        
        // Alle anderen Demo-Buttons zurücksetzen
        document.querySelectorAll('button').forEach(function(button) {
          if (button.textContent.includes('Demo geladen')) {
            button.innerHTML = '🎵 Demo laden';
          }
        });
        
        // Stufenweise Anzeige: Erst "Demo geladen", dann Kaufen-Button
        var currentButton = this;
        setTimeout(function() {
          var fixedPlayerTrackTitle = document.querySelector('.fixed-audio-player .track-title');
          if (fixedPlayerTrackTitle) {
            // Schritt 1: "Demo geladen" anzeigen
            fixedPlayerTrackTitle.innerHTML = '✅ Demo geladen';
            console.log('Fixed Player Status gesetzt: Demo geladen');

            // Schritt 2: Nach 2 Sekunden Button AN GLEICHER STELLE anzeigen
            setTimeout(function() {
              var isProductPage = window.location.pathname.includes('/products/');
              
              if (!isProductPage) {
                // Handle aus Button-Daten holen
                var productHandle = currentButton.dataset.handle;
                
                if (!productHandle) {
                  // Versuche Handle aus window.similarTracks zu finden
                  if (window.similarTracks) {
                    var matchingTrack = window.similarTracks.find(function(track) {
                      return track.sku === sku;
                    });
                    if (matchingTrack && matchingTrack.handle) {
                      productHandle = matchingTrack.handle;
                    }
                  }
                  
                  // Fallback: Handle aus Titel erstellen
                  if (!productHandle) {
                    productHandle = createHandleFromTitle(product);
                  }
                }
                
                console.log('Ersetze "Demo geladen" durch Kaufen-Button für:', product, 'Handle:', productHandle);
                
                if (productHandle) {
                  // Button DIREKT in track-title einfügen (ersetzt "Demo geladen")
                  currentDemoProduct = {
                    handle: productHandle,
                    title: product
                  };
                  
                  fixedPlayerTrackTitle.innerHTML = '<button class="inline-buy-btn" onclick="goToProductPage()" style="background: linear-gradient(135deg, #d4af37, #b8941f); color: white; border: none; padding: 4px 8px; border-radius: 4px; font-size: 11px; font-weight: bold; cursor: pointer; transition: all 0.3s ease;">Jetzt bestellen</button>';
                  
                  // Pulsing nach 3 Sekunden
                  setTimeout(function() {
                    var inlineBtn = document.querySelector('.inline-buy-btn');
                    if (inlineBtn) {
                      inlineBtn.style.animation = 'pulse-buy 2s infinite';
                      console.log('Pulsing-Animation gestartet');
                    } else {
                      console.log('Button für Pulsing nicht gefunden');
                    }
                  }, 3000);
                  
                  console.log('Inline Kaufen-Button angezeigt für:', product);
                }
              }
            }, 2000); // 2 Sekunden warten
          }
        }, 500);
      }
    });
  });
});

// ========================================
// KAUFEN-BUTTON FUNKTIONEN
// ========================================

var currentDemoProduct = null;

// Zur aktuell geladenen Produktseite navigieren
function goToProductPage() {
  if (currentDemoProduct && currentDemoProduct.handle) {
    console.log('Navigiere zu Produktseite:', currentDemoProduct.handle);
    window.location.href = '/products/' + currentDemoProduct.handle;
  } else {
    console.log('Kein aktuelles Demo-Produkt gefunden');
  }
}

// Verbesserte Handle-Erstellung aus Titel
function createHandleFromTitle(title) {
  return title.toLowerCase()
    .replace(/ä/g, 'ae')
    .replace(/ö/g, 'oe') 
    .replace(/ü/g, 'ue')
    .replace(/ß/g, 'ss')
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}
